import { createRouter, createWebHistory, NavigationGuardNext, RouteLocationNormalized, RouteRecordRaw } from 'vue-router'

/* VISTAS DE PAGINAS DE ATERRIZAJE */ 
import HomeView from '@/modules/Home/HomeView.vue'
import ContactView from '@/modules/Contact/ContactView.vue'
import ProductsView from '@/modules/Products/ProductsView.vue'
import ProductView from '@/modules/Product/ProductView.vue'
import BrandView from '@/modules/Brands/BrandView.vue'
import NotView from '@/modules/404/NotView.vue'
import CartView from '@/modules/Cart/CartView.vue'




const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    components: {
      default: HomeView
      //menu: NavWeb
    },
    meta: {
      title: '',
      description: 'Rodamientos Huánuco, distribuidor autorizado de SKF del Perú, ofrece soluciones sostenibles en rodamientos y repuestos industriales y automotrices. Encuentra productos de alta calidad para optimizar el rendimiento de tus equipos con un enfoque en la eficiencia y la durabilidad.'
    }
  },
  {
    path: '/acerca-de',
    name: 'acerca-de',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    components: {
      default: () => import(/* webpackChunkName: "about" */ '../modules/About/AboutView.vue'),
    } ,
    meta: {
      title: 'Acerca de',
      description: 'Fundado en 1989, en Rodamientos Huánuco, somos distribuidores autorizados de SKF en Lima Perú, especializados en la venta de rodamientos y rodajes en La Victoria. Ofrecemos soluciones de alta calidad para la industria y el sector automotriz, garantizando productos duraderos y eficientes para optimizar el rendimiento de tus equipos.'
    }
  },
  {
    path: '/marcas',
    name: 'marcas',
    components: {
      default: BrandView
    },
    meta: {
      title: 'Marcas',
      description: 'En rodamientos huanuco distribuidor autorizado de SKF tambien trabajamos con diferentes marcas como: NTN, KOYO, TIMKEN y etc'
    }
  },
  {
    path: '/productos',
    name: 'productos',
    components: {
      default: ProductsView
    },
    meta: {
      title: 'Productos',
      description: 'Descubre rodamientos y repuestos industriales de calidad en Rodamientos Huánuco. Con más de 35 años de experiencia, garantizamos durabilidad y rendimiento para maquinaria automotriz e industrial.'
    }
  },
  {
    path: '/productos/:producto',
    name: 'producto',
    components: {
      default: ProductView
    },
    meta: {
      title: `Producto`,
      description: `Adquiere nuestros ${window.location.pathname.split('/')[2]} con el mejor precio, diseñado para mejorar el rendimiento de tu maquinaria. Con materiales de alta calidad, garantiza durabilidad y eficiencia en diversas aplicaciones. ¡Optimiza tus proyectos hoy!`
    }
  },
  {
    path: '/compra',
    name: 'compra',
    components: {
      default: CartView
    },
    meta: {
      title: 'Carrito de Compras',
      description: `Adquiere nuestros ${window.location.pathname.split('/')[2]} con el mejor precio, diseñado para mejorar el rendimiento de tu maquinaria. Con materiales de alta calidad, garantiza durabilidad y eficiencia en diversas aplicaciones. ¡Optimiza tus proyectos hoy!`
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: '404',
    meta: {
      title: '',
      description: 'Pagina no encontrada',
    },
    components: {
      default: NotView
    },
  }
  
]


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 }
  }
})

router.beforeEach((to, from, next) => {
  const title: string | undefined = to.meta.title as string | undefined;
  const description: string | undefined = to.meta.description as string || 'Rodamientos Huánuco, Distribuidores de repuestos industriales y automotrices';

  const metaDescription = document.querySelector('meta[name="description"]');


  redirectTiendaToHome(to, from, next);


  if (to.meta.title) {
    document.title = `${title} - Rodamientos Huanuco`;
    metaDescription?.setAttribute('content', description);
  }else {
    document.title = `Rodamientos Huanuco`;
    metaDescription?.setAttribute('content', description);
  }
  next();

});


function redirectTiendaToHome(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
  if(to.meta.path != to.meta.redirect) {
    next('/');
  }
  else if(to.path === '/contacto') {
    next('/');
  }
  next();
}

export default router